/* eslint-disable @typescript-eslint/ban-ts-comment */
import { coinbaseWallet } from 'wagmi/connectors';

import type { WalletAdapter } from '../../types';
import { Icon } from './icon';

export const coinbaseId = 'coinbase';
export const coinbaseName = 'Coinbase';

export const getCoinbaseConnector = (): any => {
  return coinbaseWallet({
    appName: globalThis.window?.location?.hostname,
    preference: 'eoaOnly',
  });
};

export const Coinbase: WalletAdapter = () => ({
  walletName: coinbaseName,
  walletId: coinbaseId,
  type: coinbaseWallet.type,
  Icon,
  detector: () => true,
  getConnector: getCoinbaseConnector,
});
